import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '@material-ui/core';

export function Address({ rowData, showName }) {
    const [address, setAddress] = useState<any>();

    useEffect(() => {
        if(rowData){
            setAddress({
                street: rowData.street ?? rowData.streetAddress,
                city: rowData.city,
                state: rowData.state,
                zip: rowData.zip,
                zip4: rowData.zip4,
                homePhone: rowData.homePhone,
                cellPhone: rowData.cellPhone,
                workPhone: rowData.workPhone,
            })
        }
    }, [rowData])

    if(!address || Object.values(address).every(a => a === null)) return (
            <Card style={{textAlign:"center"}}>
                <CardContent>
                    <div>No address information provided.</div>
                </CardContent>
            </Card>
        );

    return (
        <Card style={{textAlign:"center"}}>
            <CardContent>
                {showName && <div>{rowData.firstName} {rowData.lastName}</div>}
                <div>{address.street}</div>
                <div>{address.city && `${address.city},`} {address.state} {address.zip}</div>
                {address.homePhone &&
                    <div>Home#: {address.homePhone}</div>
                }
                {address.cellPhone &&
                    <div>Cell#: {address.cellPhone}</div>
                }
                {address.workPhone &&
                    <div>Work#: {address.workPhone}</div>
                }
            </CardContent>
        </Card>
    );
}